import { render, staticRenderFns } from "./af-branches.vue?vue&type=template&id=3bc853f2&"
import script from "./af-branches.vue?vue&type=script&lang=ts&"
export * from "./af-branches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports